<template>
    <v-card
            class="mx-auto"
    >
        <v-toolbar
                class="ludi-blue"
                dark
        >

            <v-toolbar-title>Nous cherchons une grande variété de profil</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon>
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
        </v-toolbar>

        <v-list three-line>
            <template v-for="(item, index) in items">
                <v-subheader
                        v-if="item.header"
                        :key="item.header"
                        v-text="item.header"
                ></v-subheader>

                <v-divider
                        v-else-if="item.divider"
                        :key="index"
                        :inset="item.inset"
                ></v-divider>

                <v-list-item
                        v-else
                        :key="item.title"
                        @click=""
                >
                    <v-list-item-avatar>
                        <v-img :src="'./img/profiles/'+item.avatar"></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title v-html="item.title"></v-list-item-title>
                        <v-list-item-subtitle v-html="item.subtitle"></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-list>
    </v-card>
</template>

<script>
    export default {
        name: "Profiles",
        data: () => ({
            items: [
                {header: 'Liste non exhaustive'},
                {
                    avatar: 'developper.jpg',
                    title: 'Développeur',
                    subtitle: "<span class='text--primary'>Les bâtisseurs de code</span> &mdash; Tous type de profils recherchés, une préférence pour les développeurs ayant une expérience en programmation de jeux vidéo et web.",
                },
                {divider: true, inset: true},
                {
                    avatar: 'designer.jpg',
                    title: 'Graphiste',
                    subtitle: "<span class='text--primary'>Les peintres du numérique</span> &mdash; Tous type de profils recherchés, une affinité avec le pixel art est un plus.",
                },
                {divider: true, inset: true},
                {
                    avatar: '3d.jpg',
                    title: 'Infographiste 3d',
                    subtitle: "<span class='text--primary'>Les sculpteurs du numérique</span> &mdash; Tous type de profils recherchés, une affinité avec la création de jeu est un plus.",
                },
                {divider: true, inset: true},
                {
                    avatar: 'robot.png',
                    title: 'Ingénieurs électronique / mécanique',
                    subtitle: "<span class='text--primary'>Les bâtisseurs d'objets</span> &mdash; Tous type de profils recherchés, une affinité avec la création de jeu est un plus.",
                },
                {divider: true, inset: true},
                {
                    avatar: 'guitar.jpg',
                    title: 'Musiciens',
                    subtitle: "<span class='text--primary'>L'âme sonore des projets</span> &mdash; Tous type de profils recherchés.",
                },
                {divider: true, inset: true},
                {
                    avatar: 'game.jpg',
                    title: 'Game designer',
                    subtitle: "<span class='text--primary'>L'esprit ludique</span> &mdash; Tous type de profils recherchés, la motivation et la passion restent le plus important.",
                },


            ],
        }),
    }
</script>

<style scoped>

</style>